module.exports = __webpack_public_path__ + "static/showcase_videozz-ef1dd027baf0c3c77676225b4b2cdaa8.mp4";